import LockedChannel from "./LockedChannel";

export default LockedChannel;
